/* APP */
import 'core-js'; // Compatibilité IE ES6
import 'intersection-observer'; // Compatibilité IE Barba.js
import 'popper.js';
import 'bootstrap';
import 'owl.carousel';
import '@fortawesome/fontawesome-pro/js/all';
import '@fancyapps/fancybox'
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';
import { Gmap } from './map';
import { mapStyles } from './map-style';
import 'jquery-datetimepicker';
import './wad-popup';

$(document).ready(function() {
    /*
        $('#book-form').hide();
        $('body').on('click', '.book-form-open', function(event) {
            if($(this).data('room')) {
                $('#book-form-room').val($(this).data('room'));
            }
            else {
                $('#book-form-room').val('');
            }
            $('#book-form').slideDown();
            event.preventDefault(true);
            return false;
        });
        $('body').on('click', '.book-form-close', function(event) {
            $('#book-form').slideUp();
            event.preventDefault(true);
            return false;
        });
    */
    $(window).scroll(function() {
        if ($(window).scrollTop() >= 50) {
            $('body').addClass('scrolled');
        }
        else {
            $('body').removeClass('scrolled');
        }
    });
    /*
        $.datetimepicker.setLocale('fr');
        $("#book-form-startdate").datetimepicker({
            timepicker: false,
            format: 'd/m/Y',
            formatDate: 'd/m/Y',
            lang: 'fr',
            onShow: function( ct ){
                this.setOptions({
                    maxDate: jQuery('#book-form-enddate').val() ? jQuery('#book-form-enddate').val() : false
                });
            },
            minDate: 0
        });
        $("#book-form-enddate").datetimepicker({
            timepicker: false,
            format: 'd/m/Y',
            formatDate: 'd/m/Y',
            lang: 'fr',
            onShow: function( ct ) {
                this.setOptions({
                    minDate: jQuery('#book-form-startdate').val() ? jQuery('#book-form-startdate').val() : false
                });
            }
        });

        $("#book-form-form").submit(function(event) {
            event.preventDefault(true);
            let url = $(this).attr('action') + "?Language=fr-FR&Room=" + $("#book-form-room").val() + "&Arrival=" + cubilisFormatDate($("#book-form-startdate").val()) + "&Departure=" + cubilisFormatDate($("#book-form-enddate").val());
            window.open(url);
            return false;
        });
    */
    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    })

    bookAnimation();
    barbaInit();
    owlInit();
    gmapInit();

    checkScroll();
    $(window).scroll(checkScroll);
});


/*
function cubilisFormatDate(date){
    let moment = require('moment');
    let dateobj = moment(date, "DD/MM/YYYY");
    return dateobj.format('YYYY-MM-DD');
}
*/
function bookAnimation() {
    var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

    $('.book-btn').addClass('animated slow swing delay-1s').one(animationEnd, function() {
        $(this).removeClass('animated slow swing delay-1s');
    });

    $('.book-btn').hover(
        function() {
            $(this).addClass('animated slow swing infinite');
        },
        function() {
            $(this).removeClass('infinite');
            $(this).one(animationEnd, function() {
                $(this).removeClass('animated slow swing');
            });
        }
    );
}

function barbaInit() {
    barba.use(barbaPrefetch);
    barba.init({

        prevent({el}) {
            return $(el).data('fancybox') || $(el).hasClass('lang-link');
        },


        transitions: [{
            before() {
                return new Promise(resolve => {
                    //$('#book-form').slideUp();

                    $('#navbar-menu').collapse('hide');
                    $('#loader').animate({opacity: 1}, 750, resolve);
                });
            },
            after({current, next}) {
                return new Promise(resolve => {
                    window.scrollTo(0, 0);
                    $('#' + current.namespace).parent().removeClass('active');
                    $('#' + next.namespace).parent().addClass('active');
                    $('#loader').animate({opacity: 0}, 1000, resolve);
                    $('.carousel').carousel();
                    owlInit();
                    gmapInit();
                    bookAnimation();
                });
            }
        }]
    });
}

function owlInit() {
    $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 0,
        nav: false,
        dots: true,
        autoplay: true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:4
            }
        }
    });
}

function checkScroll() {
    $('.parallax').css({
        'background-position' : 'left 50% top ' + (0.4 * $(this).scrollTop()) + 'px'
    });

    $('.parallax-inverse').css({
        'background-position' : 'left 50% bottom -' + (0.4 * $(this).scrollTop()) + 'px'
    });
}

function gmapInit() {
    let mapPlaceElement = document.getElementById('map');
    if (mapPlaceElement){
        const key = 'AIzaSyDKYPwgNTPSyetmCgkWnHIk9z8AZwraLOs';
        const center = { lat: 50.021580, lng: 5.341947 };
        const options = {
            zoom: 10,
            styles: mapStyles,
        };
        let gmap = new Gmap(key,center,options);

        gmap.loadGoogleMapsApi().then(function(googleMapsApi) {
            gmap.googleMapsApi = googleMapsApi;
            gmap.createMap(mapPlaceElement);
            let markerOptions = {
                title: 'Le Moulin d\'en Bas',
                icon: {
                    path: "M20,0C9,0,0,9,0,20s20,32,20,32s20-21,20-32S31,0,20,0z M20,28c-5.5,0-10-4.5-10-10S14.5,8,20,8s10,4.5,10,10 S25.5,28,20,28z M20,12c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S23.3,12,20,12z",
                    scale: 0.70,
                    strokeOpacity: 0,
                    fillColor: '#8bc141',
                    fillOpacity: 1,
                    scrollwheel: false,
                    anchor: {
                        x: 18,
                        y: 50,
                    }
                },
            }
            gmap.addMarker(markerOptions);
        });
    }
}
